import { getAddressSuggestion } from './getAddressSuggestion';

export function serializeAddress(suggestions: Array<YMaps.ISuggestResult> = []) {
  return suggestions.map(getAddressSuggestion);
}
